// src/services/posSettingsService.js
import { apiDelete, apiGet, apiPost, apiPut } from "../utils/api";

export const getPosStoreSettings = async () => {
  const res = await apiGet("/pos-settings/store");
  return res?.data?.settings || null;
};

export const savePosStoreSettings = async (payload) => {
  const res = await apiPut("/pos-settings/store", payload);
  return res?.data?.settings || null;
};

export const uploadPosStoreAsset = async (kind, file) => {
  const formData = new FormData();
  formData.append("file", file);
  const res = await apiPost(`/pos-settings/store/${kind}`, formData);
  return res?.data?.settings || null;
};

export const deletePosStoreAsset = async (kind) => {
  const res = await apiDelete(`/pos-settings/store/${kind}`);
  return res?.data?.settings || null;
};
